"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M7.35 9.24 3.69 12.9l3.65 3.66L11 12.9z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M7.34 6.41.86 12.9l6.49 6.48 6.49-6.48zm0 10.15L3.69 12.9l3.66-3.66L11 12.9zm12.02-9.92C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72"
}, "1")], 'Rotate90DegreesCcwTwoTone');